module.exports = __webpack_public_path__ + "img/product_category_preview_image-2.aa0bfff.jpg";